<template>
    <div>
        <DemographicsInformation />
        <ServiceLocations class="mt-2" />
        <FacesheetComments class="mt-2" />
    </div>
</template>

<script src="./Demographics.ts"></script>
